import api from "@/utils/axios";

export default {
  async getOffices(username) {
    const { data } = await api.get("/offices", {
      params: { usr: username },
    });
    return data;
  },
  async getOfficesByRegional() {
    const { data } = await api.get("/offices/all-by-regional");
    return data;
  },
  async getEmployees() {
    const { data } = await api.get("/users/employees");
    return data;
  },
  async getPrUsers() {
    const { data } = await api.get("/purchase-request-users");
    return data;
  },
  async getPrUser(id) {
    const { data } = await api.get(`/purchase-request-users/${id}`);
    return data;
  },
  async createPrUser(payload) {
    const { data } = await api.post("/purchase-request-users", payload);
    return data;
  },
  async updatePrUser(id, payload) {
    const { data } = await api.put(`/purchase-request-users/${id}`, payload);
    return data;
  },
  async deletePrUser(id) {
    const { data } = await api.delete(`/purchase-request-users/${id}`);
    return data;
  },
  async getPrNumber(ofc, yr) {
    const { data } = await api.get("/pr/generate", {
      params: { ofc: ofc, yr: yr },
    });
    return data;
  },
  async getApprover(code, ofc) {
    const { data } = await api.get("/pr/approver", {
      params: { code: code, ofc: ofc },
    });
    return data;
  },
  async getOfficePic(ofc) {
    const { data } = await api.get("/pr/office-pic", {
      params: { ofc: ofc },
    });
    return data;
  },
  async submitRequest(payload, type, user, isDashboard = false) {
    const config = {};
    if (isDashboard) {
      config.headers = { 'X-Source-App': 'dashboard' };
    }
    const { data } = await api.post(
      "/pr/requests",
      {
        payload,
        type,
        user,
      },
      config
    );
    return data;
  },
  async getHierarchyStatuses() {
    const { data } = await api.get("/hierarchy-status");
    return data;
  },
  async getHierarchyItemsGroup() {
    const { data } = await api.get("/items-group");
    return data;
  },
  async fetchPRList(params, isDashboard = false) {
    const config = { params };
    if (isDashboard) {
      config.headers = { 'X-Source-App': 'dashboard' };
    }
    const { data } = await api.get("/pr/requests/data", config);
    return data;
  },
  async exportExcel(params) {
    const response = await api.get("/pr/requests/export-excel", {
      params,
      responseType: 'blob', // Important for downloading files
    });
    return response;
  },
  async exportProcurementExcel(params) {
    const response = await api.get("/pr/requests/export-procurement-excel", {
      params,
      responseType: 'blob',
    });
    return response;
  },
  async fetchPr(id, isDashboard = false) {
    const config = {};
    if (isDashboard) {
      config.headers = { 'X-Source-App': 'dashboard' };
    }
    const { data } = await api.get(`/pr/requests/${id}`, config);
    return data;
  },
  async fetchBulkPrs(paramsObj, isDashboard = false) {
    const apiParams = {};
    if (paramsObj.nos) apiParams.nos = paramsObj.nos.join(",");
    if (paramsObj.ids) apiParams.ids = paramsObj.ids.join(",");
    
    const config = { params: apiParams };
    if (isDashboard) {
      config.headers = { 'X-Source-App': 'dashboard' };
    }

    const { data } = await api.get("/pr/requests/bulk-details", config);
    return data;
  },
  async checkApprover(username) {
    const { data } = await api.get("/pr/check-approver", {
      params: { username },
    });
    return data;
  },
  async submitPrs(ids, user) {
    const { data } = await api.post("/pr/requests/submit", {
      ids,
      user,
    });
    return data;
  },
  async cancelPrs(ids, user, note) {
    const { data } = await api.post("/pr/requests/cancel", {
      ids,
      user,
      note,
    });
    return data;
  },
  async updateRequest(id, payload, type, user, isDashboard = false) {
    const config = {};
    if (isDashboard) {
      config.headers = { 'X-Source-App': 'dashboard' };
    }
    const { data } = await api.put(
      `/pr/requests/${id}`,
      {
        ...payload,
        type,
        user,
      },
      config
    );
    return data;
  },
  async rejectItem(itemId, user, note = "") {
    const { data } = await api.post(`/pr/requests/items/${itemId}/reject`, {
      user,
      note,
    });
    return data;
  },
  async undoRejectItem(itemId, user) {
    const { data } = await api.post(
      `/pr/requests/items/${itemId}/undo-reject`,
      {
        user,
      },
    );
    return data;
  },
  async approvePr(id, user, note) {
    const { data } = await api.post(`/pr/requests/approve`, {
      ids: [id],
      user,
      note,
    });
    return data;
  },
  async approveBulkPrs(ids, user, note) {
    const { data } = await api.post(`/pr/requests/approve`, {
      ids,
      user,
      note,
    });
    return data;
  },
  async confirmFinance(id, user, note) {
    const { data } = await api.post(`/pr/requests/confirm-finance`, {
      ids: [id],
      user,
      note,
    });
    return data;
  },
  async confirmBulkFinance(ids, user, note) {
    const { data } = await api.post(`/pr/requests/confirm-finance`, {
      ids,
      user,
      note,
    });
    return data;
  },
  async requestAdjustment(ids, user, note) {
    const { data } = await api.post(`/pr/requests/request-adjustment`, {
      ids,
      user,
      note,
    });
    return data;
  },
  async rejectPr(id, user, note) {
    const { data } = await api.post(`/pr/requests/reject`, {
      ids: [id],
      user,
      note,
    });
    return data;
  },
  async rejectBulkPrs(ids, user, note) {
    const { data } = await api.post(`/pr/requests/reject`, {
      ids,
      user,
      note,
    });
    return data;
  },
  async pendingPr(id, user, note) {
    const { data } = await api.post(`/pr/requests/pending`, {
      ids: [id],
      user,
      note,
    });
    return data;
  },
  async openPendingPr(id, user, note = "") {
    const { data } = await api.post(`/pr/requests/${id}/open-pending`, {
      user,
      note,
    });
    return data;
  },
  async listPrItems(id, payload, user) {
    const { data } = await api.put(`/pr/requests/${id}/list-items`, {
      ...payload,
      user,
    });
    return data;
  },
  async getRecapPrs(params) {
    const { data } = await api.get("/recap-prs", {
      params,
    });
    return data;
  },
  async getDashboardRecapPrs(params) {
    const { data } = await api.get("/dashboard-recap-prs", {
      params,
    });
    return data;
  },
  async getTopItems(params) {
    const { data } = await api.get("/top-items", {
      params,
    });
    return data;
  },
  async getPoItemGroupRecap(params) {
    const { data } = await api.get("/po-item-group-recap", {
      params,
    });
    return data;
  },
  async exportPoItemGroupRecapExcel(params) {
    const response = await api.get("/po-item-group-recap/export-excel", {
      params,
      responseType: "blob",
    });
    return response;
  },
  async getListedPrItems(params) {
    const { data } = await api.get("/pr/requests/listed-items", {
      params,
    });
    return data;
  },
  async resolveToken(tkn) {
    try {
      const { data } = await api.get("/pr/requests/resolve-token", {
        params: { tkn },
      });
      return data;
    } catch (error) {
      // Return the error response body so the caller can show the API message
      return (
        error?.response?.data ?? {
          success: false,
          message: "Token is invalid or has already expired.",
        }
      );
    }
  },
  async forceOpenPR(prId, username) {
    const { data } = await api.post(`/pr/requests/${prId}/force-open`, {
      user: username,
    });
    return data;
  },
  async bypassReceivedPrs(ids, user, note = "") {
    const { data } = await api.post("/pr/requests/bypass-received", {
      ids,
      user,
      note,
    });
    return data;
  },
  async getDurationReport(prId) {
    const { data } = await api.get(`/pr/requests/${prId}/duration-report`);
    return data;
  },
  async getSlaPerformance(params) {
    const { data } = await api.get("/analytics/sla-performance", { params });
    return data;
  },
  async getSlaBreachDetails(params) {
    const { data } = await api.get("/analytics/sla-breaches-detail", { params });
    return data;
  },
  async getRevisionFlowDetails(params) {
    const { data } = await api.get("/analytics/revision-flow-details", { params });
    return data;
  },
  async resolveFilterToken(token) {
    const { data } = await api.get("/pr/requests/resolve-filter-token", {
      params: { ftkn: token },
    });
    return data;
  },
  async uploadAnalysisFiles(prId, formData) {
    const { data } = await api.post(`/pr/requests/${prId}/analysis-files`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  async deleteAnalysisFile(prId, fileId, delete_reason) {
    const { data } = await api.delete(`/pr/requests/${prId}/analysis-files/${fileId}`, {
      data: { delete_reason },
    });
    return data;
  },
  async uploadSupportingDocuments(prId, formData) {
    const { data } = await api.post(`/pr/requests/${prId}/supporting-documents`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  async deleteSupportingDocument(prId, fileId, delete_reason) {
    const { data } = await api.delete(`/pr/requests/${prId}/supporting-documents/${fileId}`, {
      data: { delete_reason },
    });
    return data;
  },
};
